import React from "react"
import { useLocation } from 'react-router-dom'
import queryString from 'query-string'

import PartyLogin from '../components/PartyLogin'

export default function PartyLoginPage() {
    const { search } = useLocation()
    const nickname = decodeURI(queryString.parse(search).nickname)
    const invite = queryString.parse(search).invite
    const end = queryString.parse(search).end   

    return (
        <div className="party-setting">
            <div className="party">
                <PartyLogin nickname={nickname} invite={invite === 'true'} end={end === 'true'} />
            </div>
        </div>
    )
}